import { getUserFriendlyErrorMessage, ErrorMessages } from './error-message.utils';

export function getApiErrorMessage(
  error: unknown,
  fallbackMessage: string
): string {
  const messages: ErrorMessages = {
    unauthorized: fallbackMessage,
    forbidden: fallbackMessage,
    notFound: fallbackMessage,
    serverUnavailable: fallbackMessage,
    offline: fallbackMessage,
    validationError: fallbackMessage,
    generic: fallbackMessage,
  };
  
  return getUserFriendlyErrorMessage(error, messages);
}
